import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import Todo from "./Todo";

export default function TodoList() {
    const todos = useSelector((state) => state.todos);
    const filters = useSelector((state) => state.filters);
    const { status } = filters;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTodos);
    }, [dispatch]);

    const filterByStatus = (todo) => {
        const { status } = filters;
        switch (status) {
            case "Complete":
                return todo.completed;

            case "Incomplete":
                return !todo.completed;

            default:
                return true;
        }
    };

    const filterByColors = (todo) => {
        const { colors } = filters;
        if (colors.length > 0) {
            return colors.includes(todo?.color);
        }
        return true;
    };

    const filterByCompleted = todo => todo.completed;
    const filterByInCompleted = todo => !todo.completed;

    return (
       <>
         <div className="mt-5 mb-5 text-gray-700 text-sm max-h-[300px]">
            {status !== "Complete" && <h1 className="mt-10">InCompleted</h1> }
            {todos
                .filter(filterByStatus)
                .filter(filterByColors)
                .filter(filterByInCompleted)
                .map((todo) => (
                    <Todo todo={todo} key={todo.id} />
                ))}
        </div>
        <div className="text-gray-700 text-sm max-h-[300px] overflow-y-auto">
            {status !== "Incomplete" && <h1 className="mt-10">Completed</h1> }
            {todos
                .filter(filterByStatus)
                .filter(filterByColors)
                .filter(filterByCompleted)
                .map((todo) => (
                    <Todo todo={todo} key={todo.id} />
                ))}
        </div>
       </>
    );
}
